






















import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import SubHeader from "@/components/SubHeader.vue";
import Navigation from "@/components/Navigation.vue";
import { Getter } from "vuex-class";

@Component({
  components: {
    Header,
    SubHeader
  }
})
export default class CompleteUserPage extends Vue {
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  gotoRevNo() {
    this.$router.push({ name: "reservationNumber" });
  }
  gotoCustomer() {
    this.$router.push({
      name: "usercustomer",
      params: { code: this.yoyakuNo }
    });
  }
}
